import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { settingsService } from '@/services/settings';
import ButtonIcon from '@/components/ui/ButtonIcon';
import { useMobileNavSidebar } from '@/hooks/useUserPreferences';
import { useCurrentUser } from '@/services/userHooks';
import { handleLogout } from '@/utils/logout';

export const Route = createFileRoute('/_app/settings')({
  loader: async () => {
    try {
      return await settingsService.getSettings();
    } catch (error) {
      console.error('Failed to load settings:', error);
      throw error;
    }
  },
  component: SettingsPage,
  errorComponent: SettingsError,
});

export function SettingsPage() {
  const { toggleMobileNavSidebar } = useMobileNavSidebar();
  const { currentUser } = useCurrentUser();

  return (
    <div className="flex h-full flex-col">
      {/* Page Header */}
      <div className="border-default bg-surface-primary flex-between z-header sticky top-0 border-b px-5 py-3 md:px-10 md:py-4">
        {/* Mobile hamburger menu */}
        <div className="md:hidden">
          <ButtonIcon
            icon="hamburger"
            title={t`Menu`}
            onClick={toggleMobileNavSidebar}
            className="text-copy-secondary"
          />
        </div>

        <div className="page_title">
          <h1 className="page-title text-[15px] font-semibold">
            <Trans>Settings</Trans>
          </h1>
        </div>
        <div className="top_buttons text-right">
          <button
            onClick={() => {
              if (currentUser?.formKey) {
                handleLogout(currentUser.formKey);
              }
            }}
            className="text-copy-primary text-xs hover:underline"
          >
            <Trans>Sign Out</Trans>
          </button>
        </div>
      </div>

      {/* Child Route Content */}
      <div className="single_page_content flex-1 p-5 md:p-10">
        <Outlet />
      </div>
    </div>
  );
}

function SettingsError() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-gray-600">
          <Trans>Sorry, there was an error. Please try again.</Trans>
        </p>
      </div>
    </div>
  );
}
